export const CONFETTI_HERO_IMAGE_LEFT =
  'https://media-api.xogrp.com/images/fe189bf3-158d-489e-84de-9ec168c9a75b';
export const CONFETTI_HERO_IMAGE_RIGHT =
  'https://media-api.xogrp.com/images/244834e1-5964-45ee-9769-7e74928db7a8';
